module.exports = __webpack_public_path__ + "static/media/SV.0da52670.svg";